import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import TimeEditable, {TimeEditableProps} from 'notebook/protocols/editor/TimeEditable';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {Step} from '../StepConstants';

interface Props extends Omit<TimeEditableProps, 'placeholderZeros' | 'time_seconds' | 'cid'> {
  step?: Step;
}

class TimeEditableWrapper extends React.Component<Props> {
  timeEditableRef = React.createRef<HTMLElement>();
  override componentDidMount(): void {
    const type = this.props.showSeconds ? 'HH:MM:SS' : 'HH:MM';
    $(this.timeEditableRef.current!).tooltip({
      title: `Aggregate Time - ${type}`,
      placement: 'bottom',
      container: 'body',
      delay: {
        show: 300,
      },
    });
  }

  override componentWillUnmount(): void {
    $(this.timeEditableRef.current!).tooltip('destroy');
  }

  override render(): JSX.Element {
    let newProps = {
      ...this.props,
      placeholderZeros: false,
      time_seconds: this.props.step!.time_seconds,
      cid: this.props.step!.cid,
      rootRef: this.timeEditableRef,
    };
    // eslint-disable-next-line no-restricted-syntax
    newProps = _.omit(newProps, 'step');

    return (
      <div className="time-editable-wrapper">
        <TimeEditable {...newProps} />
        <BenchlingIcon className="time-editable-wrapper-icon" icon="clock" />
      </div>
    );
  }
}

export default TimeEditableWrapper;
